// The one-shot "you just added a company" moment for the notification nudge.
//
// Adding a contact is the point of highest intent, so the conversation the user
// lands in right after shows the nudge once. In-memory on purpose: this is a
// moment, not a state — an app restart has the persistent nudge on the threads
// list anyway.

let freshAdd = false;

export function markFreshAdd(): void {
  freshAdd = true;
}

/** Reads and clears the flag — the nudge shows on exactly one screen visit. */
export function consumeFreshAdd(): boolean {
  const value = freshAdd;
  freshAdd = false;
  return value;
}
